import {Component, OnInit} from '@angular/core';
import {DisplayableValueDTO, InventoryLocationDTO} from "../../../services/api/api";
import {ModalNavigationService} from "../../../services/gui/modal/modal-navigation.service";
import {ImageUploadModel} from "../../../services/gui/image/model";
import {UtilService} from "../../../services/util.service";

@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  styleUrls: ['./inventory-details.component.scss'],
  standalone: false,
})
export class InventoryDetailsComponent implements OnInit {
  constructor(
    private modalNavigation: ModalNavigationService,
    public util: UtilService
  ) {}

  isInModalContext: boolean;
  inventoryData: any;
  inventoryElement: InventoryLocationDTO;

  avatarUrl: string = './assets/img/no-image.png';
  headerUrl: string = './assets/img/location-placeholder-bg.jpg';

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.inventoryData = this.modalNavigation.getCurrentNavigation().data.location;
      this.inventoryElement = this.inventoryData.displayValue;
    }
    this.avatarUrl =
      this.inventoryElement && this.inventoryElement.logo
        ? this.util.appendQueryParamToUrl(<string>(<unknown>this.inventoryElement.logo.url), 'thumbnail=L')
        : './assets/img/no-image.png';
    this.headerUrl =
      this.inventoryElement && this.inventoryElement.headerImage
        ? this.util.appendQueryParamToUrl(<string>(<unknown>this.inventoryElement.headerImage.url), '')
        : './assets/img/location-placeholder-bg.jpg';
  }

  getSelectedLocationCoords() {
    if (this.inventoryElement && this.inventoryElement.address && this.inventoryElement.address.position) {
      return {
        x: this.inventoryElement.address.position.coordinates[0],
        y: this.inventoryElement.address.position.coordinates[1],
      };
    }
  }
}
